import React from 'react';
import PropTypes from 'prop-types';

import { validatePersonNameUniqueness } from '!m/utils';

import FieldGroup from '../FieldGroup';
import BoundNameField from '@c/BoundNameField';
import BoundRadioGroup from '@c/BoundRadioGroup';
import withHandleNameConflicts from 'hocs/withHandleNameConflicts';
import Spacer from '@wui/layout/spacer';

class Spouse extends React.Component {
  static contextTypes = {
    testator: PropTypes.object,
    clientDataHolder: PropTypes.object,
  };

  static propTypes = {
    handleNameConflicts: PropTypes.func.isRequired,
  };

  nameValidations() {
    return [
      validatePersonNameUniqueness(
        this.context.clientDataHolder.clientData,
        this.context.testator.spouse,
      ),
    ];
  }

  get areInitialFieldsDisabled() {
    return false;
  }

  get isPlanningForSpouseDisabled() {
    // Don't enable the question until the user has
    //   entered something for the name and gender
    //   fields.
    return !this.context.testator.spouse.name;
  }

  showSpouseFields() {
    // If the user is not married, questions
    //   about the spouse are not needed at
    //   all.
    return this.context.testator.isMarried;
  }

  render() {
    if (!this.showSpouseFields()) {
      return null;
    }

    const { handleNameConflicts } = this.props;

    return (
      <FieldGroup level={1} title="Your Spouse">
        <BoundNameField
          label="Spouse's Full Name"
          obj={this.context.testator.spouse}
          disabled={this.areInitialFieldsDisabled}
          additionalValidations={this.nameValidations()}
          onBlur={handleNameConflicts(this.context.testator.spouse)}
          helperText="Enter your spouse's first and last name as it appears on their government-issued ID."
        />
        <Spacer v={16} />
        <BoundRadioGroup
          path="isPlanningForSpouse"
          disabled={this.isPlanningForSpouseDisabled}
          label="Do you want to create documents for both of you?"
          style={{ marginTop: '16px' }}
        />
      </FieldGroup>
    );
  }
}

export default withHandleNameConflicts(Spouse);
